import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mtb",
  "aria-label": "Основная навигация"
}
const _hoisted_2 = {
  key: 0,
  class: "mtb__profile"
}
const _hoisted_3 = { class: "mtb__profile-head" }
const _hoisted_4 = { class: "mtb__profile-info" }
const _hoisted_5 = { class: "mtb__profile-name" }
const _hoisted_6 = {
  key: 0,
  class: "mtb__profile-dep"
}
const _hoisted_7 = {
  key: 1,
  class: "mtb__profile-email"
}

import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import LifeBridge from '@tnlife/tn-bridge';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileTabBar',
  setup(__props) {

/**
 * Мобильный нижний тап-бар (паттерн мини-аппов TN Life, ср. fura/TheTabbar).
 * Виден только на ≤768px, на верхнеуровневом экране списка форм; работает
 * и в standalone, и в iframe/WebView мини-аппа (в отличие от topbar).
 */
const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const me = computed(() => authStore.me);

// В мини-аппе TN Life профиль и выход предоставляет суперапп —
// свой пункт «Профиль» показываем только в standalone.
const isMiniApp = LifeBridge.isIFrame || LifeBridge.isWebView;

const currentTab = computed<'mine' | 'available'>(() =>
  route.query.tab === 'available' ? 'available' : 'mine'
);

function goTab(tab: 'mine' | 'available'): void {
  router.replace({
    name: 'forms',
    query: tab === 'available' ? { tab } : {},
  });
}

const profileOpen = ref(false);

const initials = computed(() => {
  const n = me.value?.fullName || '';
  return n
    .split(/[\s\u00b7]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
});

async function handleLogout(): Promise<void> {
  profileOpen.value = false;
  await authStore.logout();
  router.push({ name: 'forms' });
}

return (_ctx: any,_cache: any) => {
  const _component_TNIcon = _resolveComponent("TNIcon")!
  const _component_TNUserPicture = _resolveComponent("TNUserPicture")!
  const _component_TNButton = _resolveComponent("TNButton")!
  const _component_TNBottomSheet = _resolveComponent("TNBottomSheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (me.value)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["mtb__item", { 'mtb__item--active': currentTab.value === 'mine' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goTab('mine')))
          }, [
            _createVNode(_component_TNIcon, {
              name: "list",
              size: 22
            }),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mtb__label" }, "Мои", -1))
          ], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["mtb__item", { 'mtb__item--active': currentTab.value === 'available' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goTab('available')))
          }, [
            _createVNode(_component_TNIcon, {
              name: "people",
              size: 22
            }),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mtb__label" }, "Доступные", -1))
          ], 2),
          (!_unref(isMiniApp))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["mtb__item", { 'mtb__item--active': profileOpen.value }]),
                "aria-label": "Профиль",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (profileOpen.value = true))
              }, [
                _createVNode(_component_TNIcon, {
                  name: "user",
                  size: 22
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mtb__label" }, "Профиль", -1))
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_unref(isMiniApp))
      ? (_openBlock(), _createBlock(_component_TNBottomSheet, {
          key: 1,
          "is-open": profileOpen.value,
          header: { title: 'Профиль' },
          "teleport-to": "body",
          onHide: _cache[3] || (_cache[3] = ($event: any) => (profileOpen.value = false))
        }, {
          default: _withCtx(() => [
            (me.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_TNUserPicture, {
                      text: initials.value,
                      size: "m",
                      square: true,
                      class: "mtb__profile-avatar"
                    }, null, 8, ["text"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(me.value.fullName), 1),
                      (me.value.department)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(me.value.department), 1))
                        : _createCommentVNode("", true),
                      (me.value.email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(me.value.email), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_TNButton, {
                    secondary: "",
                    block: "",
                    icon: "backto",
                    onClick: handleLogout
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("Выйти", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["is-open"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})